
function MiddenCirkel({ middleRadius, circleWidth, chartClicked }) {



  return (

    <g className="Zon">
      <circle
        r={middleRadius + 6*circleWidth}
        cx='0'
        cy='0'
        fill="url('#sunGradient')"
        opacity='1'
        onClick={() => chartClicked()}
        filter='grayscale(100%)'
      />
      {/* <text textAnchor='middle' fontSize='10'>KLIMAATVERANDERING</text> */}
    </g>

  );


}

export default MiddenCirkel;
